export const cabinApi = {
    getCabins: 'v1/api/cabin',
    createCabins: 'v1/api/cabin',
    editCabins: 'v1/api/cabin',
    deteleCabins: 'v1/api/cabin',
    addVoucher:'v1/api/voucherDetails',
    getUserVoucher:'v1/api/voucherDetails/createdUsers',
    getVoucherCodes:'v1/api/voucherDetails/voucherCodes',
    getVoucherList:'v1/api/voucherDetails',
    updatedVoucher:'v1/api/voucherDetails/changeStatus',
    getVoucherListById:'v1/api/voucherDetails/voucherCodes',
    createDeadline: 'v1/api/universityDeadlines',
    editDeadline: 'v1/api/universityDeadlines/getById/',
    getLoans: 'v1/api/loan-provider',
    addLoanProvider: 'v1/api/loan-provider',
    updateLoanProvider: 'v1/api/loan-provider',
};
